import type { FaireProductEntity } from "../../entity_types/product";

export const p_9zkx125d27: FaireProductEntity = {
  token: "p_9zkx125d27",
  type: "product",
  name: "Hot Chocolate Jug",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/5bd2fa35b6a9fb0319579decda2c4737251e54de10450d0b37950d8fb7ddc346.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd8c395bc14049014d0d79373c6d4f8af79f4eaeb5a68e58e37fc28743f0e149.jpeg",
    "https://cdn.faire.com/fastly/8fe3df9d7c2c79d7c54a31bbd3bc74257aa73814a4cc9a5bcda98da1d5715f0f.jpeg",
    "https://cdn.faire.com/fastly/c7e73e852f1bbbea325bcb715e97c5f3a14347fcf05bac1d65f600f1e36fb582.jpeg",
    "https://cdn.faire.com/fastly/335470a0ab3168d83e0dbf63e563384ab479faf5a210070913e5ac66e991cba1.jpeg",
    "https://cdn.faire.com/fastly/27e1ae689787872ffdfc47cdddd14ac73e04323f7d308d9ee3d53504f8b5b6a5.jpeg",
    "https://cdn.faire.com/fastly/8d576a544d215c4005fcc29b39e58a0a688e990a97a40d9d89dfba7f1a8f5605.jpeg",
    "https://cdn.faire.com/fastly/207975b3eae39761c951e5bc8089f2d79447acc698400d4d91cef250eb5da25b.jpeg",
  ],
  priceDollars: 35,
  description:
    'The best way to make Mexican Hot Chocolate is with clay cookware - a Mexican Kitchen’s staple. Passed down by the Aztecs, it’s still preferred for the unique flavor it lends to food. \n\nThe jug can be used directly over heat (a flame or electric range) - just add milk and chocolate. Try it with the food of the Gods, Oaxacan chocolate, and whisk until frothy with the molinillo. The pot can also be used to heat teas, soups, and coffee. And can we talk about its triple functionality as a vase or decoration? You’ll be impressed.\n\nNote: This jug is a cooking vessel, and not recommended as a water pitcher as the terracotta clay will sweat. The condensation that collects on the outside is normal, and does not imply that the jug is leaking.\n\n*Lead-Free\n\nDimensions: 9" H (to rim) 14.5" H (to top of handle) 4.5" Diameter at rim, 22" Diameter at center, 3.5" Diameter at base.\n\nCapacity: Appx. 68 oz / 2 Liters (these are all handmade so variations in size will occur).',
  tags: [],
  msrpDollars: 70,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:59.865Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
